import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IWebHookVersion } from '@/shared/model/web-hook-version.model';
import { ResourceInterface } from '@/shared/component/resource.interface';

const baseApiUrl = 'api/private/web-hook-versions';

export default class WebHookVersionService implements ResourceInterface {
  public find(id: number): Promise<IWebHookVersion> {
    return new Promise<IWebHookVersion>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public create(entity: IWebHookVersion): Promise<IWebHookVersion> {
    return new Promise<IWebHookVersion>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public update(entity: IWebHookVersion): Promise<IWebHookVersion> {
    return new Promise<IWebHookVersion>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
